import logo from './ne-logo.png'
import Toggle from '../Toggle/Toggle'
import { Link } from 'react-router-dom'

function Header(){
    return(
        <header className="w-full p-4 bg-garfield-header grid grid-cols-6 gap-4">
            <Link className="w-64" to="/">
                <img className="w-64 col-start-1 col-end-3" src={logo} alt="nebraskainteractivelogo"/>
            </Link>
            <span className="col-start-5 col-span-2 md:col-start-6"><Toggle /></span>
        </header>
    )
}

export default Header;